/**
 * Frontend mirror of the backend feedback enums + limits.
 * Keep this file aligned with InviteCloudBackend/src/feedback/constants.ts.
 */
import type {
  FeedbackPriority,
  FeedbackStatus,
  FeedbackType,
} from '@/src/infrastructure/lib/api';

export const FEEDBACK_TYPE_OPTIONS: { value: FeedbackType; label: string; hint: string }[] = [
  { value: 'BUG', label: 'Bug', hint: "Something's broken or behaving unexpectedly" },
  { value: 'FEATURE_REQUEST', label: 'Feature request', hint: "Something we don't yet support" },
  { value: 'PERFORMANCE', label: 'Performance', hint: 'The app feels slow or unresponsive' },
  { value: 'PAYMENT_ISSUE', label: 'Payment issue', hint: 'A billing or checkout problem' },
  { value: 'UI_UX', label: 'UI / UX', hint: 'Confusing layout, copy, or interaction' },
  { value: 'GENERAL', label: 'General', hint: 'Anything else on your mind' },
  { value: 'OTHER', label: 'Other', hint: "If nothing else fits" },
];

export const RATING_LABELS: Record<number, string> = {
  1: 'Poor',
  2: 'Bad',
  3: 'Average',
  4: 'Good',
  5: 'Excellent',
};

export const STATUS_LABEL: Record<FeedbackStatus, string> = {
  OPEN: 'Open',
  IN_REVIEW: 'In review',
  RESOLVED: 'Resolved',
  REJECTED: 'Rejected',
  CLOSED: 'Closed',
};

export const STATUS_TONE: Record<FeedbackStatus, string> = {
  OPEN: 'bg-amber-500/15 text-amber-700 border-amber-500/30',
  IN_REVIEW: 'bg-sky-500/15 text-sky-700 border-sky-500/30',
  RESOLVED: 'bg-emerald-500/15 text-emerald-700 border-emerald-500/30',
  REJECTED: 'bg-rose-500/15 text-rose-700 border-rose-500/30',
  CLOSED: 'bg-zinc-500/15 text-zinc-700 border-zinc-500/30',
};

export const PRIORITY_TONE: Record<FeedbackPriority, string> = {
  LOW: 'text-zinc-500',
  MEDIUM: 'text-sky-600',
  HIGH: 'text-amber-600',
  CRITICAL: 'text-rose-600',
};

export const VALIDATION = {
  TITLE_MIN: 5,
  TITLE_MAX: 120,
  DESCRIPTION_MIN: 20,
  DESCRIPTION_MAX: 3000,
  ATTACHMENT_MAX_COUNT: 5,
  ATTACHMENT_MAX_BYTES: 10 * 1024 * 1024,
  ALLOWED_MIMES: ['image/png', 'image/jpeg', 'image/webp', 'application/pdf'] as const,
};
